import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagSK = function FlagSK() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
    fill: "#F0F0F0",
    d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#0052B4",
    d: "M25 50c13.807 0 25-11.193 25-25 0-3.058-.55-5.988-1.555-8.696H1.555A24.946 24.946 0 0 0 0 25c0 13.807 11.193 25 25 25Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#D80027",
    d: "M25 50c10.75 0 19.913-6.784 23.445-16.304H1.555C5.088 43.216 14.251 50 25 50Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#F0F0F0",
    d: "M6.464 14.13v12.472c0 7.094 9.268 9.268 9.268 9.268s9.267-2.174 9.267-9.268V14.131H6.464Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#D80027",
    d: "M8.639 14.13v12.472c0 .833.185 1.62.551 2.357h13.085a5.23 5.23 0 0 0 .551-2.357V14.131H8.639Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#F0F0F0",
    d: "M20.08 22.826h-3.261v-2.174h2.174v-2.174h-2.174v-2.174h-2.174v2.174h-2.174v2.174h2.174v2.174h-3.26V25h3.26v2.174h2.174V25h3.26v-2.174Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#0052B4",
    d: "M12.156 31.994c1.4.88 2.84 1.391 3.576 1.618.737-.227 2.177-.738 3.578-1.619 1.412-.887 2.402-1.903 2.965-3.034a3.787 3.787 0 0 0-3.06-.598 3.805 3.805 0 0 0-6.965 0 3.805 3.805 0 0 0-3.06.598c.562 1.131 1.553 2.146 2.966 3.035Z"
  }));
};
FlagSK.displayName = 'FlagSK';
export default withFlagWrapper(FlagSK);
//# sourceMappingURL=index.js.map